<template>
    <div class="mb-5 ma-3">
        <v-autocomplete
                item-value="id"
                item-text="title"
                :search-input.sync="taskTitle"
                :items="searchTasks"
                :loading="isLoading"
                return-object
                @change="createNew($event)"
                v-if="canAdd != null"
                label="Søk for oppgave å føre timer på"
                flat
        >
            <template v-slot:item="{ item }">
                <v-tooltip right max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item-content v-on="on" v-bind="attrs">
                            <v-list-item-subtitle>
                                <div v-for="fId in item.parentIds" v-if="fId != 'IEAARZFPI7777777'" :key="fId"><small>{{getFolder(fId).title}}</small></div>
                                <div v-for="fId in item.superParentIds" v-if="fId != 'IEAARZFPI7777777'" :key="fId"><small>{{getFolder(fId).title}}</small></div>
                            </v-list-item-subtitle>
                            <v-list-item-title v-text="item.title"></v-list-item-title>
                            <v-list-item-subtitle v-text="item.briefDescription"></v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                    <span v-html="item.description"></span>
                </v-tooltip>
            </template>
        </v-autocomplete>
        <!-- START Modal -->
        <v-dialog v-model="dialog" max-width="700px">
            <v-card>
                <v-card-title>
                    <span class="headline">
                        {{getTask(editedItem.taskId).title}}
                        <a class="ma-2" :href="getTask(editedItem.taskId).permalink" _target="blank">
                            <i class="fas fa-external-link-alt"></i>
                        </a>
                    </span>
                    <br>
                    <span :class="getTaskColor(editedItem.taskId)">{{getTaskType(editedItem.taskId)}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                        v-model.number="editedItem.hours"
                                        type="number"
                                        label="Timer"
                                        step="0.5"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-select label="Faktureringstype" :items="taskTypes" v-model="editedItem.taskType"></v-select>
                            </v-col>
                            <v-col>
                                <v-textarea
                                        counter
                                        :rows="3"
                                        autofocus
                                        clearable
                                        v-model="editedItem.comment"
                                        label="Kommentar"
                                        rows="15"
                                        auto-grow
                                        filled
                                        outlined
                                ></v-textarea>
                            </v-col>
                            <v-col>
                                <v-date-picker v-model="editedItem.trackedDate"></v-date-picker>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                
                <v-card-actions>
                    <v-btn color="error" text @click="deleteItem(editedItem)">
                        <v-icon color="error">fas fa-trash</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <small>Opprettet: {{editedItem.createdDate | dateTime}} <br>
                        Uppdatert: {{editedItem.updatedDate | dateTime}}</small>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="primary darken-1" text @click="save" v-if="!editedItemUpdateStatus">Save</v-btn>
                    <v-btn color="primary darken-1" text disabled v-if="editedItemUpdateStatus == 'loading'"><i
                            class="fas fa-spin fa-spinner"></i></v-btn>
                    <v-btn color="error darken-1" text @click="save" v-if="editedItemUpdateStatus == 'failed'">Retry
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- END Modal -->
        <!-- START Card -->
        <v-card class="mx-auto">
            <!-- Chart -->
            <chart v-if="chartData" :data="chartData" :options="{responsive:true,legend: {display:true}}"></chart>
            <!-- Card Header -->
            <v-toolbar>
                <v-btn icon @click="goBack">
                    <v-icon>fas fa-arrow-left</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title @dblclick="editDate = true">
                    <span v-if="unit == 'month'">
                        <v-menu v-model="editDate">
                            <template v-slot:activator="{ on, attrs }">
                                <span>Måned: {{time.start.format('MMMM YYYY')}}</span>
                            </template>
                            <v-date-picker type="month" :value="time.start.format('YYYY-MM-DD')" @change="changeStartDate"></v-date-picker>
                        </v-menu>
                    </span>
                    <span v-if="unit == 'day'">
                        <v-menu v-model="editDate">
                            <template v-slot:activator="{ on, attrs }">
                                <span>Dag: {{time.start.format('DD.MM.YYYY')}}</span>
                            </template>
                            <v-date-picker first-day-of-week="1" :value="time.start.format('YYYY-MM-DD')" v-if="editDate" @change="changeStartDate"></v-date-picker>
                        </v-menu>
                    </span>
                    <span v-if="unit == 'week'">
                        <v-menu v-model="editDate">
                            <template v-slot:activator="{ on, attrs }">
                                <span>Uke {{time.start.week()}}: {{time.start.format('DD.MM')}} - {{time.end.format('DD.MM')}}</span>
                            </template>
                            <v-date-picker first-day-of-week="1" show-week :allowed-dates="weekStartDates" :value="time.start.format('YYYY-MM-DD')" v-if="editDate" @change="changeStartDate"></v-date-picker>
                        </v-menu>
                    </span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="goForward">
                    <v-icon>fas fa-arrow-right</v-icon>
                </v-btn>
            </v-toolbar>
            
            <!-- START list of hours -->
            <v-list three-line subheader>
                <v-expansion-panels :value="unit == 'day' ? 0 : ''">
                    <v-expansion-panel :key="title">
                        <v-expansion-panel-header>
                            <v-subheader v-if="!loading">
                                <span>Totalt: {{totalHours}}</span>
                                <span class="ma-2">Fakturerbare: {{invoicedHours}} ({{invoicePercent}}%)</span>
                                <v-spacer></v-spacer>
                                <div :title="'Oppdatert ' + loadDateFromNow">
                                    Oppdatert {{loadDateFromNow}}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <button v-bind="attrs" v-on="on" class="fas fa-redo" :class="loading ? 'fa-spin' : ''" @click.stop="update(true)"></button>
                                        </template>
                                        <span>Oppdater</span>
                                    </v-tooltip>
                                </div>
                                <v-spacer></v-spacer>
                                <span class="error--text" v-if="missingHours > 0">Mangler: {{missingHours}}</span>
                            </v-subheader>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-list-item v-for="timelog in timelogs.data" :key="timelog.id" @click="editItem(timelog)">
                                <v-list-item-avatar :color="getTaskColor(timelog.taskId)">
                                    <v-icon v-text="timelog.hours"></v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div><div v-for="fId in getTask(timelog.taskId).parentIds" v-if="fId != 'IEAARZFPI7777777'" :key="fId"><small>{{getFolder(fId).title}}</small></div>
                                                <div v-for="fId in getTask(timelog.taskId).superParentIds" v-if="fId != 'IEAARZFPI7777777'" :key="fId"><small>{{getFolder(fId).title}}</small></div>
                                                <h3><span v-on="on">{{getTask(timelog.taskId).title}}</span></h3>
                                                </div>
                                            </template>
                                            <span>{{getTaskType(timelog.taskId)}} {{getTask(timelog.taskId).title}}</span>
                                        </v-tooltip>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{timelog.trackedDate}}: {{timelog.comment}}</v-list-item-subtitle>
                                </v-list-item-content>
            
                                <v-list-item-action>
                                    <v-btn
                                            :href="getTask(timelog.taskId).permalink"
                                            target="_blank"
                                            @click.stop
                                            @mousedown.stop
                                            @touchstart.native.stop
                                    >
                                        <v-icon>fas fa-external-link-alt</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-list>
        </v-card>
    </div>
</template>

<script>
    import api from "../api"
    import moment from "moment"
    import Chart from "./Chart.vue"
    import tasksMixin from '@/mixins/tasks'
    
    export default {
        name: "hourlist",
        props: ["start", "end", "title", "step", "unit", "cache", "canAdd", "user"],
        components: { Chart },
        mixins: [tasksMixin],
        data(){
            return {
                isLoading: false,
                seachHandlerTimeout: null,
                taskTitle: "",
                searchTasks: [],
                dialog: false,
                loading: true,
                time:{
                    start:this.start || moment().startOf(this.unit),
                    end: this.end || (this.start ? this.start.clone() : moment()).startOf(this.unit).add(this.step, this.unit),
                },
                headers: [
                    {text: "Kommentar", value: "comment"},
                    {text: "Timer", value: "hours"},
                    {text: "Sak", value: "task"},
                    {text: "Actions", value: "actions", sortable: false},
                ],
                timelogs: {
                    data: [],
                },
                error: null,
                editedIndex: null,
                editedItem: {
                    comment: "",
                    hours: "",
                    trackedDate: "",
                },
                editedItemUpdateStatus: null,
                settings: {
                    workHours: 7.5,
                },
                editDate: false
            }
        },
        filters:{
            dateTime(date){ return moment(date).format('DD.MM.YYYY HH:mm:SS')}
        },
        computed: {
            loadDate(){
                if(!this.timelogs.loaded) return null
                return moment(this.timelogs.loaded, "DD.MM.YYYY HH:mm:ss")
            },
            loadDateFromNow(){
                return this.loadDate.fromNow()
            },
            loadedSince(){
                return moment().diff(this.loadDate, 'seconds')
            },
            totalHours(){
                return Number(this.timelogs.data.reduce((a, i) => a + i.hours, 0.0))
            },
            invoicedHours(){
                return Number(this.timelogs.data.filter(t=> ["Timebasert", "Fastpris", "GuruLabs"].indexOf(this.getTaskType(t.taskId)) > -1).reduce((a, i) => a + i.hours, 0.0))
            },
            missingHours(){
                if(this.settings.workHours - this.totalHours <= 0.0){
                    return 0.0
                }else{
                    return Number(this.settings.workHours - this.totalHours)
                }
            },
            invoicePercent(){
                if(this.invoicedHours > 0) return Math.round(this.invoicedHours / this.totalHours * 100 * 100) / 100
                return 0.0
            },
            allTasksFetched(){
                if(!this.timelogs.data) return false
                
                for(let i in this.timelogs.data){
                    let tl = this.timelogs.data[i]
                    if(!this.tasks[tl.taskId]) return false
                }
                return true
            },
            chartData(){
                if(!this.allTasksFetched) return false
                return this.updateChartData()
            },
        },
        methods: {
            weekStartDates: val => moment(val, 'YYYY-MM-DD').isoWeekday() === 1,
            changeStartDate(event){
                this.editDate = false
                this.time.start = moment(event, 'YYYY-MM-DD').startOf(this.unit)
                this.time.end = this.time.start.clone().add(1, this.unit)
                this.update()
            },
            createNew(task){
                task.loaded = new Date()
                this.$set(this.tasks, task.id, task)
                this.editItem({taskId:task.id, trackedDate: moment().format("YYYY-MM-DD")})
            },
            goForward(){
                if(!this.time.start) this.time.start = moment().startOf(this.unit)
                if(!this.time.end) this.time.end = this.time.start.clone().add(this.step, this.unit)
                this.time.start.add(this.step, this.unit)
                this.time.end.add(this.step, this.unit)
                this.update()
            },
            goBack(){
                if(!this.time.start) this.time.start = moment().startOf(this.unit)
                if(!this.time.end) this.time.end = this.time.start.clone().add(this.step, this.unit)
                this.time.start.subtract(this.step, this.unit)
                this.time.end.subtract(this.step, this.unit)
                this.update()
            },
            updateChartData(){
                let buckets = {}
                for(let i in this.timelogs.data){
                    let tl = this.timelogs.data[i]
                    
                    let key = this.getTaskType(tl.taskId) ? this.getTaskType(tl.taskId) : ""
                    if(!buckets[key]){
                        buckets[key] = Number(tl.hours)
                    }else{
                        buckets[key] = Number(buckets[key]) + Number(tl.hours)
                    }
                }
                buckets["Manglende"] = this.missingHours // manglende det er det man ikke har ført.
                
                let labels = this.taskTypes.concat(["Manglende"])

                // This array is a color representation of the taskTypes collection in src/mixins/tasks.js
                // The color in this array is matched to the task type based on their positions in each array.
                let colors = [
                    this.$vuetify.theme.themes[this.$vuetify.theme.dark ? 'dark' : 'light'].success,
                    this.$vuetify.theme.themes[this.$vuetify.theme.dark ? 'dark' : 'light'].info,
                    this.$vuetify.theme.themes[this.$vuetify.theme.dark ? 'dark' : 'light'].warning,
                    this.$vuetify.theme.themes[this.$vuetify.theme.dark ? 'dark' : 'light'].info,
                    this.$vuetify.theme.themes[this.$vuetify.theme.dark ? 'dark' : 'light'].error,
                    this.$vuetify.theme.themes[this.$vuetify.theme.dark ? 'dark' : 'light'].accent,
                    this.$vuetify.theme.themes[this.$vuetify.theme.dark ? 'dark' : 'light'].secondary,
                ]
                
                let resp = {labels:[]}
                let dataset = { data: [], backgroundColor:[] }
                for(let i in labels){
                    let label = labels[i]
                    if(buckets[label] > 0){
                        resp.labels.push(label)
                        dataset.data.push(buckets[label])
                        dataset.backgroundColor.push(colors[i])
                    }
                }
                
                resp.datasets = [dataset]

                console.log(buckets);
                
                return resp
            },
            save(){
                if(this.editedIndex > -1){
                    let currentItem = this.timelogs.data[this.editedIndex]
                    let changes = {}
                    if(this.editedItem.hours != currentItem.hours) changes.hours = Number(this.editedItem.hours)
                    if(this.editedItem.comment != currentItem.comment) changes.comment = this.editedItem.comment
                    if(this.editedItem.trackedDate != currentItem.trackedDate) changes.trackedDate = this.editedItem.trackedDate
    
                    if(changes.hours || changes.comment || changes.trackedDate){
                        this.editedItemUpdateStatus = "loading"
                        api.PUT('/hours/' + currentItem.id, changes)
                        .then(data => {
                            Object.assign(
                                this.timelogs.data[this.editedIndex],
                                this.editedItem,
                            )
                            this.editedItemUpdateStatus = null
                        }).catch(err => {
                            this.editedItemUpdateStatus = "failed"
                        }).finally(() => this.close())
                    }
                }else{
                    // we create new timelog
                    this.editedItemUpdateStatus = "loading"
                    api.POST('/tasks/' + this.editedItem.taskId + "/timelogs", {hours:this.editedItem.hours, comment:this.editedItem.comment, trackedDate:this.editedItem.trackedDate})
                    .then(data => {
                        this.timelogs.data.push(data.data[0])
                        this.editedItemUpdateStatus = null
                    })
                    .finally(() => this.close())
                }
    
                if(this.editedItem.taskType != this.getTaskType(this.editedItem.taskId)){
                    this.editedItemUpdateStatus = 'loading'
                    let type = this.editedItem.taskType == "Ukjent" ? [''] : this.editedItem.taskType
                    api.PUT('/tasks/' + this.editedItem.taskId, {customFields:JSON.stringify([{id:"IEAARZFPJUAAA6YZ", value:type}])})
                    .then(data => {
                        this.editedItemUpdateStatus = null
                        let element = data.data[0]
                        element.loaded = new Date()
                        this.$set(this.tasks, element.id, element)
                    }).catch(err=>{
                        this.editedItemUpdateStatus = "failed"
                    }).finally(() => this.close())
                }
            },
            close(){
                this.dialog = false
                this.$nextTick(() => {
                    this.editedIndex = null
                })
            },
            editItem(item){
                this.editedIndex = this.timelogs.data.indexOf(item)
                item.taskType = this.getTaskType(item.taskId)
                this.editedItem = Object.assign({}, item)
                this.editedItemUpdateStatus = null
                this.dialog = true
            },
            deleteItem(item){
                if(confirm("Are you sure you want to delete this item?")){
                    this.editedItemUpdateStatus = "loading"
                    api.DELETE('/hours/'+item.id).then(data => {
                        let index = this.timelogs.data.indexOf(item)
                        this.timelogs.data.splice(index, 1)
                        this.editedItemUpdateStatus = null
                        this.close()
                    }).catch(err => {
                        console.log(err)
                        this.editedItemUpdateStatus = "failed"
                    })
                }
            },
            update(refresh){
                let url = "/hours"
                if(this.time.start){
                    url += "?start=" + this.time.start.format("DD.MM.YYYY")
                    
                    if(!this.time.end){
                        url += "&end=" + this.time.start.clone().add(this.step, this.unit).format("DD.MM.YYYY")
                    }else{
                        url += "&end=" + this.time.end.format("DD.MM.YYYY")
                    }
                }
                if(this.$route && this.$route.query && this.$route.query.user) url += "&user=" + this.$route.query.user
                if(refresh) localStorage.removeItem(url)
                this.loading = true
                api.GET(url)
                .then(data => {
                    this.timelogs = data
                    this.loading = false
                    this.getMissingTasks(this.timelogs.data, refresh)
                })
            },
            populateInitialSeachTasks(){
                let url = "/seachTasks?scheduledDate=" + JSON.stringify({start:moment().startOf('week').format('YYYY-MM-DD'), end:moment().startOf('week').add(1, 'week').format("YYYY-MM-DD")})
                url += "&sortField=UpdatedDate&sortOrder=Desc&me=true"
                this.isLoading = true
                api.GET(url).then(data => {
                    this.storeTasks(data)
                    this.getMissingFolders(data.data.map(t=>t.id))
                    this.searchTasks = data.data
                }).finally(() => this.isLoading = false)
            }
        },
        mounted(){
            this.update(!this.cache)
            if(this.canAdd != null) this.populateInitialSeachTasks()
        },
        watch:{
            taskTitle: function(newVal) {
                if(newVal != null && newVal.length > 1){
                    // Items have already been requested
                    this.seachHandlerTimeout = setTimeout(() => {
                            this.isLoading = true
                            let url = '/seachTasks?limit=50&sortField=UpdatedDate&sortOrder=Desc&title='+newVal
                            api.GET(url).then((data) => {
                                this.storeTasks(data)
                                this.getMissingFolders(data.data.map(t=>t.id))
                                this.searchTasks = data.data
                            }).finally( () => this.isLoading = false)
                        }, 200
                    )
                }
            }
        }
    }
</script>
<style>
    .v-menu__content{
        width: 33% !important;
    }
    .v-icon.v-icon{
        font-size: 20px !important;
    }
</style>